import { Injectable } from '@angular/core';
import { AbstractEntityService } from './base/abstractEntityService';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from '@app/core/environment/environment.service';
import { ErrorService } from '@app/core/error/error.service';
import { Router } from '@angular/router';
import { EntityCV } from '../model/cv/EntityCV.model';
import { Worklog } from '../model/entity/worklog.model';

@Injectable({
  providedIn: 'root'
})
export class WorklogService extends AbstractEntityService {

  constructor(
    public httpClient: HttpClient,
    public environmentService: EnvironmentService,
    public errorService: ErrorService,
    public router: Router
  ) {
    super(httpClient, environmentService, router, errorService);
  }

  getEntityName(): string {
    return EntityCV.all.WORKLOG;
  }

  getURLIdFromEntity(worklog: Worklog): string {
    return String(worklog.id);
  }
}
